import type { FC, ReactElement } from 'react';
import React, { Children, cloneElement } from 'react';

import { Anchor } from './Anchor.js';

type Props = {
  addAnchors?: boolean | string;
  children: ReactElement;
};

const AddAnchors: FC<Props> = ({ addAnchors, children }) => {
  if (addAnchors) {
    const addAnchorsPrefix = addAnchors && (addAnchors === true ? 'rcv-block' : addAnchors);
    const firstAnchorKey = `${addAnchorsPrefix}-first`;
    const lastAnchorKey = `${addAnchorsPrefix}-last`;
    return (
      <>
        <Anchor type={'first'} anchorKey={firstAnchorKey} />
        {cloneElement(Children.only(children), { addAnchorsPrefix })}
        <Anchor type={'last'} anchorKey={lastAnchorKey} />
      </>
    );
  }
  return children;
};

export default AddAnchors;
